module.exports = __webpack_public_path__ + "static/media/Trash.66f5e5f7.png";